import { render, staticRenderFns } from "./SetBigScreet.vue?vue&type=template&id=104950c6&scoped=true&"
import script from "./SetBigScreet.vue?vue&type=script&lang=js&"
export * from "./SetBigScreet.vue?vue&type=script&lang=js&"
import style0 from "./SetBigScreet.vue?vue&type=style&index=0&id=104950c6&prod&scoped=true&lang=css&"
import style1 from "./SetBigScreet.vue?vue&type=style&index=1&id=104950c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104950c6",
  null
  
)

export default component.exports